import { PercentPipe } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { AudienceCountry } from '@cuepid/enterprise/core/models/instagram/audience-statistic';
import { ChartOptions } from 'chart.js';
import { Colors } from 'ng2-charts';

@Component({
  selector: 'app-instagram-audience-country',
  templateUrl: './instagram-audience-country.component.html',
  styleUrls: ['./instagram-audience-country.component.scss'],
  providers: [PercentPipe],
})
export class InstagramAudienceCountryComponent implements OnChanges {
  @Input() audienceCountry?: AudienceCountry;

  readonly colors: Colors[] = [{ backgroundColor: ['#EF94B3', '#6B629E'] }];
  readonly labels = ['国内', '海外'];
  readonly options: ChartOptions = {
    tooltips: {
      callbacks: {
        label: (
          tooltipItem: Chart.ChartTooltipItem,
          data: Chart.ChartData
        ): string => {
          const index = tooltipItem.index as number;
          const label = data.labels?.[index];
          const value = data.datasets?.[0].data?.[index] as string;
          return `${label}: ${this.percentPipe.transform(value, '1.1')}`;
        },
      },
    },
  };

  inJapan = 0;
  others = 0;

  constructor(private readonly percentPipe: PercentPipe) {}

  ngOnChanges(): void {
    if (!this.audienceCountry) {
      this.inJapan = 0;
      this.others = 0;
      return;
    }

    this.inJapan = this.audienceCountry.jp / this.audienceCountry.sum;
    this.others = this.audienceCountry.other / this.audienceCountry.sum;
  }
}
